<div class="slidebar" :class="size">
    <!-- <div>{{data}}</div> -->
    <div :class="disable?'disable_all':''">
        <div v-if="lock||disable" class="lock"></div>
        <div class="title" v-if="title">
            {{title}} 
        </div>
        <button @click="value_add(-difference, false)" class="btn" :class="value<=0?'disable':'able'" :disabled="value<=0 ? true : false"
        :tabindex="disable ? -1 : 0">
            <iCon class="icon" iconClass="asus_proart_sw_ico_last" style=" width: 19px;height: 19px;"></iCon>
        </button>
        <div class="bar">
        <button v-for="item in _data" class="slider_point" :class="[value>=item.value?'able':'disable']" 
            :style="['margin-left:'+item.left+'px;']" @click="onclick(item.index)"
            :tabindex="disable ? -1 : 0">
            <p v-if="!isTemperature">{{item.text}}</p>
            <p v-else>{{item.text*100}}</p>
        </button>
        <Slider v-model="value" :max="step" :min="0" @change="slider_change"></Slider>
        </div>
        <button @click="value_add(difference, true)" class="btn" :class="value>=this._step*(this._data.length-1)?'disable':'able'"
            :tabindex="disable ? -1 : 0" >
            <iCon class="icon" iconClass="asus_proart_sw_ico_next-more" style=" width: 19px;height: 19px;"></iCon>
        </button>
        <div class="value" :class="{'disableInput' : disableInput }">
            <input type="number"  id="input_value" :value="_value" @paste="pasteInput($event)" 
            @change="onchange" @keydown="intOnly($event)" :disabled="disableInput" 
            v-bind:style="{ width: 81-right_fix+'px' , 'padding-right':51+right_fix +'px'}"
            :tabindex="disable ? -1 : 0"/>
            <p v-bind:style="{ right: right_fix + 'px' }">{{unit}}</p>
            <iCon v-if="lock" iconClass="asus_proart_sw_ico_lock" class="settingIcon"></iCon>
            <p v-if="_max" class="full">Max</p>
            <p v-if="_min" class="full">Min</p>
        </div>
    </div>
</div>